import { render, staticRenderFns } from "./password-write.vue?vue&type=template&id=3c60bca0&scoped=true"
import script from "./password-write.vue?vue&type=script&lang=js"
export * from "./password-write.vue?vue&type=script&lang=js"
import style0 from "./password-write.vue?vue&type=style&index=0&id=3c60bca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c60bca0",
  null
  
)

export default component.exports